import n,{internals as t}from"./ClassAdder.svelte.js";const e=Object.assign({},t);function r(r){return new Proxy(n,{construct:function(n,s){return Object.assign(t,e,r),new n(...s)},get:function(n,s){return Object.assign(t,e,r),n[s]}})}export{r as classAdderBuilder};
//# sourceMappingURL=classAdderBuilder.js.map
